const scenes = [
  {
    id: 10000,
    name: 'scene1',
    detail: 'Fenn St, Gerringong',
    icon: 'scene',
    locationLatitude: -34.737992,
    locationLongitude: 150.81636,
  },

  {
    id: 10001,
    name: 'scene2',
    detail: 'Albert st, North Parramatta NSW 2151',
    icon: 'scene',
    locationLatitude: -33.804005,
    locationLongitude: 151.009201,
  },
];

export default scenes;



// WEBPACK FOOTER //
// ./src/fixtures/scenes.js